import $ from 'jquery';

import EnteteBonEtFacture from '@/views/en-tete-bon-facture';
import Vue from 'vue';
import excel from 'vue-excel-export';
import VueHtml2pdf from 'vue-html2pdf';
 
Vue.use(excel)
Vue.use(VueHtml2pdf)

import { cca_config } from '@/config';

export const utilMixins = {
    components: {
        EnteteBonEtFacture
    },
    data() {
        return {
            assets_path: cca_config.C_URL+cca_config.C_URL_ASSET,

            // base_url_caisse: cca_config.C_URL +':'+ cca_config.MODULE.caisse.port,
            // base_url_stock: cca_config.C_URL +':'+ cca_config.MODULE.stock.port,
            // base_url_rh: cca_config.C_URL +':'+ cca_config.MODULE.rh.port,

            base_url_caisse: cca_config.C_CAISSE_FE_URL,
            base_url_stock: cca_config.C_STOCK_FE_URL,
            base_url_rh: cca_config.C_RH_FE_URL,

            default_country_code: cca_config.COUNTRY_CODE, 
            ville_le: cca_config.VILLE,

            foot_1: '',
            foot_2: '',
            foot_3: '',
            is_printing: false,
            is_sfe: cca_config.IS_SFE,
            is_modele_analyse: cca_config.IS_MODELE_ANALYSE,
            can_set_pac: cca_config.CAN_SET_PAC,

            is_exporting: false,
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            list_months: [
                { id: '', lib: "Choisir" }, 
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],
            current_date: new Date(),
        }
    },

    created() {
        document.title = cca_config.VUE_APP_NAME
    },

    mounted() {
        
    },

    methods: {
        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigits(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        formatCurrency(num) {
            return new Number(num).toLocaleString("fr-FR");
        },

        transformToNumber(value) {
            return +value
        },

        capitalizeFirstLetter(value) {
            return value[0]
        },

        shortenString(value) {
            let shorten_string = value
            // let len = value.length

            // if (len > s_len) {
            //     shorten_string = value.substr(0, s_len)+'...'
            // }

            return shorten_string
        },

        toggleCollapse(selector) {
            const el = document.getElementById(selector)
            const hd = document.querySelectorAll(".section-box")
            
            if (hd != null) {
                for (let i = 0; i < hd.length; ++i) {
                    hd[i].classList.remove('show');
                }
            }
            
            el.classList.add('show')
        },

        /**
         * Email validator
         * @param {*} email 
         * @returns 
         */
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        goTo(url) {
            this.$router.push({"path": url})

            let path = this.$route.path
            
            this.is_param = path.includes("parametres")
        },

        successToast: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        errorToast: function(message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-danger',
                type: 'danger',
                position: 'top-center'

            })
        },

        warningToast: function (message) {
            this.$toasted.show(message, {
                duration: 4000,
                action: [
                    {
                        text: "X",
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                ],
                theme: "toasted-warning",
                type: "warning",
                position: "top-center",
            });
        },

        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        formatDateToDateHour(given_date) {
            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            month = month < 10 ? "0" + month : month;

            let d = date.getDate();
            d = d < 10 ? "0" + d : d;

            only_date = d + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();

            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + "h" + c_minute;

            return only_date + " à " + only_hour;
        },

        /**
         * Forma to date to dd/mm/yyyy
         * @param {*} dateStr 
         * @returns 
         */
        formatDateToDmY: function(dateStr){
            let date = new Date(dateStr)
            let dd = (date.getDate() <= 9)?'0'+date.getDate():date.getDate();
            let mm = ((date.getMonth() + 1) <= 9)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
            let y = date.getFullYear();

            return dd + '/' + mm + '/' + y;        
        },

        /**
         * Forma to date to Y-m-d
         * @param {*} dateStr 
         * @returns 
         */
         formatDateToYmD: function(dateStr){
            let date = new Date(dateStr)
            let dd = (date.getDate() <= 9)?'0'+date.getDate():date.getDate();
            let mm = ((date.getMonth() + 1) <= 9)?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
            let y = date.getFullYear();

            return y + '-' + mm + '-' + dd;        
        },
        
        /**
         * Format hour to HHhmm (HH = Hour - mm = minute)
         * @param {*} dateStr 
         * @returns 
         */
        formatHourToHm: function(dateStr){
            let date = new Date(dateStr)
            let min =  (date.getMinutes() <= 9)?'0'+date.getMinutes():date.getMinutes();
            let hours =  (date.getHours() <= 9)?'0'+date.getHours():date.getHours();

            return hours +'h'+ min 
        },

        /**
         * Format hour to HHhmm (HH = Hour - mm = minute)
         * @param {*} dateStr 
         * @returns 
         */
        formatEnHour: function(dateStr){
            let date = new Date(dateStr)
            let min =  (date.getMinutes() <= 9)?'0'+date.getMinutes():date.getMinutes();
            let hours =  (date.getHours() <= 9)?'0'+date.getHours():date.getHours();

            return hours +':'+ min 
        },

        setDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() + 1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth()+1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        formatJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data
            }
        },

        /**
         * Ajoute un caractère (Exple. / ou ° etc.) après n chiffres
         * @param {*} n 
         * @param {} selector (est l'ID du champ input)
         */
         async formatNumberToSeparable(n, selector) {
            let nb_car = $('#' + selector).val().length;
            if (n == '1') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9m ]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + 'm ');
                }
            } else if (n == '2') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9^C°]+/g, ''))

                if (nb_car == n) {
                    $('#' + selector).val($('#' + selector).val() + '°');
                }else if (nb_car == 4) {
                    $('#' + selector).val($('#' + selector).val() + 'C');
                }
                // this.constantes.temperature = $('#' + selector).val()
            }  else if (n == '3') {
                $('#' + selector).val($('#' + selector).val().replace(/[^0-9/]+/g, ''))

                if (nb_car == 2) {
                    $('#' + selector).val($('#' + selector).val() + '/');
                }
            }
        },

        printPDF(html2PdfRef = 'html2Pdf') {
            this.is_printing = true

            this.$refs[html2PdfRef]?.generatePdf()
        },

        async beforeDownload({ html2pdf, options, pdfContent }, format, is_medical_prescription=false) {
            const newOptions = {
                ...options,
                pagebreak: {
                    mode: ['avoid-all']
                },
            }

            await html2pdf().set(newOptions).from(pdfContent).set(
                {
                    margin: [0.2, 0, 1, 0], 
                }
            ).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                this.getFooter(is_medical_prescription)

                const page_size = pdf.internal.pageSize.getWidth()
                const page_height = pdf.internal.pageSize.getHeight()

                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)

                    // pdf.setFont('Arial', 'B', 8)
                    if (format == 'a4') {
                        pdf.setFontSize(10)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    } else if (format == 'a5') {
                        pdf.setFontSize(8)
                        pdf.text(this.foot_1, (page_size / 2), (page_height - 0.7), {align: 'center'})
                        pdf.text(this.foot_2, (page_size / 2), (page_height - 0.5), {align: 'center'})
                        pdf.text(this.foot_3, (page_size / 2), (page_height - 0.3), {align: 'center'})
                    }
                } 
            }).save().then(() => {
                this.is_printing = false
            })
        },

        getFooter(is_medical_prescription) {
            // EPHATA
            this.foot_1 = cca_config.FOOT_1
            this.foot_2 = cca_config.FOOT_2

            if (is_medical_prescription) {
                this.foot_3 = cca_config.FOOT_ORD
            }
        },

        hasDownloaded() {},

        onProgress() { },

        startPagination() {},

        hasPaginated() {},

        /**
         * Uplaod file validator
         * @param max_file_size 
         * @returns 
         */
        fileValidation(max_file_size, selector) {
            $('.err-fsize').fadeOut(500)
            $('.err-extension').fadeOut(500)
            var is_valid = true
            
            var fileInput = document.getElementById(selector),
                filePath = fileInput.value
            
            // Allowing file type
            var allowedExtensions =
                    /(\.png|\.jpg|\.jpeg|\.docx|\.doc|\.xls|\.xlsx|\.ppt|\.pptx|\.pdf)$/i;
                
            if (!allowedExtensions.exec(filePath)) {
                // alert('Invalid file type');
                fileInput.value = '';
                $('.err-extension').fadeIn(500)
                is_valid = false
                return;
            } else {
    
                // Check file size
                if (fileInput.files.length > 0) {
                    for (let i = 0; i < fileInput.files.length; i++) {
                        const fsize = fileInput.files.item(i).size
                        const rlsize = Math.round(( fsize / 1024 ))
    
                        if (rlsize > max_file_size) {
                            $('.err-fsize').fadeIn(500)
                            is_valid = false
                            return;
                        } 
                    }
                }
            }

            return is_valid
        },

        /**
         * Set UID for an array of prestation
         * @param {Array} prestations  
         */
        setPrestationUID(prestations) {
            prestations.forEach((analyse, index) => {
                const tm = new Date()
                let tmp_uid = analyse.nom
                tmp_uid = tmp_uid.replace(" ", "_")
                tmp_uid = tmp_uid.replace("/", "_")
                tmp_uid = tmp_uid.toLowerCase()+''+tm.getTime()
                tmp_uid = tmp_uid.replace("  ", "_")
                tmp_uid = tmp_uid.replace(" ", "_")
                prestations[index]['uid'] = tmp_uid
            });
            return prestations
        },

        handleBeforeFinish() {
            this.is_exporting = false
        },

        /**
         * Remove special character from string
         */
        removeAccents(strAccents){
            strAccents = strAccents.split('');
            let strAccentsOut = new Array();
            let strAccentsLen = strAccents.length;
            let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
            let accentsOut = [
                'A','A','A','A','A','A','a','a','a','a','a','a','O','O','O','O','O','O','O','o',
                'o','o','o','o','o','E','E','E','E','e','e','e','e','e','C','c','D','I','I','I','I',
                'i','i','i','i','U','U','U','U','u','u','u','u','N','n','S','s','Y','y','y','Z','z'
            ];
            for (let y = 0; y < strAccentsLen; y++) {
                if (accents.indexOf(strAccents[y]) != -1) {
                    strAccentsOut[y] = accentsOut[accents.indexOf(strAccents[y])];
                }
                else
                    strAccentsOut[y] = strAccents[y];
            }
            strAccentsOut = strAccentsOut.join('');
            return strAccentsOut;
        },

        /**
         * Validate a string not to be empty
         * @param {*} value 
         */
        validateStringNotEmpty(value) {
            if (typeof value  === 'string') {
                if (value.trim().length === 0) {
                    return true
                }
            }
            return false
        },

        cleanNumber(value) {
            if (this.validateStringNotEmpty(value)) {
                return ''
            }
            value = this.transformToNumber(value)
            if (!this.validateNumber(value)) {
                return ''
            }
            return value
        },

        validateNumber(number) {
            if (isNaN(number) || typeof number !== 'number') {
              return false
            }
            return true
        },
    }
}